<template lang="pug">
	.briefs--branding-configurator
		Popup(v-if="popupVisible", ref="popup", :popupVisible.sync="popupVisible" :width="1080", :height="920", :title="$tCaption('Branding configurator')")
			.content(:class="{ 'disabled-controls': isLoading }")
				.flex-row.briefs--branding-configurator.body(ref="body", :style="{ '--mainHeight': `${elHeight}px`}")
					.flex-col.space.flex-1
						.font-big.upper.grey {{ $tCaption('Preview') }}
						.branding-configurator-scroll-wrapper
							DxScrollView.branding-configurator-scroll(showScrollbar="always")
								.easy-creative-app.app-sample(:style="brandingStyleString")
									.easy-creative.flex-col
										.flex-col.full-width.header-panel-holder.align-center.center(ref="header")
											.flex-row.align-center.center.space.header-panel.full-width
												.flex-row.align-center.space-medium
													.font-big.upper(v-if="branding && branding.CompanyName") {{branding.CompanyName}}
													img.company-logo(v-if="companyLogoUrl", :src="companyLogoUrl")
												.flex-col.space.center.powered-by
													.font-tiny.upper.grey {{$tCaption('Powered by')}}
													img.adthos-logo(:src="require('assets/logo_transparent.png')")
											.flex-row.align-center.center.space.header-stepper.full-width
												.flex-col
													.flex-row.align-center.center.space.header-stepper
														.step.flex-row.space.align-center(v-for="(step, idx) in ['Brief', 'Questions',  'Script builder']", :class="{ active: idx === 1, passed: idx <= 1 }")
															fas.grey(v-if="idx > 0", icon="right-long")
															.step-name {{step}}
													.stepper-line
														.stepper-value(:style="{ '--percent': `50%` }")
										.sample-questions
											EasyCreativeQuestions(:info="info")
					.settings.flex-col.space
						.branding-configurator-scroll-wrapper
							DxScrollView.branding-configurator-scroll
								.lr-padding
									EasyCreativeSettingsColorScheme(:info="info")
				Loader(v-if="isLoading", :fullscreen="true", text="")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false", :disabled="!!isLoading")
				DxButton(:text="$tCaption('Save', '@actions')", type="success", @click="save", :disabled="!!isLoading")
</template>

<script>
import _ from 'lodash';
import DxButton from 'devextreme-vue/button';
import Popup from 'app-core/Popup.vue';
import Loader from 'app-core/Loader.vue';
import sampleData from './sample-data.js';
import EasyCreativeQuestions from 'view/creative/EasyCreative/EasyCreativeQuestions.vue';
import DxScrollView from 'devextreme-vue/scroll-view';
import brandingsMixin from 'view/creative/EasyCreative/brandings.js';
import EasyCreativeSettingsColorScheme from 'view/creative/EasyCreative/EasyCreativeSettingsColorScheme.vue';

export default {
	translationCategory: 'briefs.BrandingConfigurator',
	components: { DxButton, Popup, Loader, EasyCreativeQuestions, DxScrollView, EasyCreativeSettingsColorScheme },
	props: [],
	mixins: [brandingsMixin],
	data() {
		return {
			popupVisible: false,
			branding: null,
			sampleData,
			predefined: null,
			elHeight: 0,
			isLoading: 0
		};
	},
	computed: {
		info() {
			return {
				predefined: this.predefined,
				lastAnswers: () => null,
				allowBack: () => false,
				briefId: 'fake',
				questions: () => ({
					allQuestions: this.sampleData.stepsQuestions[0]
				}),
				saveBriefAnswers: () => null,
				branding: this.branding,
				brandingVars: this.brandingVars,
				defaultBranding: this.defaultBranding
			}
		},
		companyLogoUrl() {
			return this.branding?.LogoUrl || this.sampleData.brief?.LogoUrl;
		},
	},
	watch: {
		
	},
	mounted() {
		if (__DEBUG__)
			window.brandingConfigurator = this;
	},
	destroyed() {
		delete this.$initBranding;
	},
	methods: {
		show(branding) {
			this.$initBranding = branding;
			this.branding = _.cloneDeep(branding);
			this.predefined = _.cloneDeep(this.sampleData);

			if (this.branding.JsonConfig && typeof(this.branding.JsonConfig) !== 'object') {
				this.branding.JsonConfig = JSON.parse(this.branding.JsonConfig) || {};
			}

			this.popupVisible = false;
			this.$nextTick(() => {
				this.popupVisible = true;
				this.$nextTick(() => this.elHeight = this.$refs.body.offsetHeight);
			});
		},
		save() {
			this.isLoading++;
			this.$initBranding.JsonConfig = this.branding.JsonConfig;
			return this.$Data.postExternalApi('BriefBranding/CreateUpdateBriefBranding', {
				...this.branding,
				JsonConfig: JSON.stringify(this.brandingVars)
			}).then((r) => {
				if (r?.Success !== false) {
					this.popupVisible = false;
				}
			}).finally(() => this.isLoading--);
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	
	.briefs--branding-configurator {
		&.body {
			position: absolute;
			top: 0px;
			left: 0px;
			bottom: 0px;
			right: 0px;
		}

		.app-sample {
			border-radius: 4px;
			overflow: hidden;

			.sample-questions {
				padding: 20px;
			}
		}

		.branding-configurator-scroll {
			height: calc(var(--mainHeight) - 55px);
		}

		.branding-configurator-scroll-wrapper {
			border-radius: 4px;
			overflow: hidden;
		}
	}

	@import "view/creative/EasyCreative/easy-creative-styles.scss";
</style>
